export * from './lib/hosted-auth';
export * from './lib/products';

export { default as FacebookIcon } from './lib/icon.svg';
export const facebookName = 'Facebook';
